import { breakpoints, sizes } from '@bnnvara/breakpoints';
import Styled, { css } from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Modal = Styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 1001;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  &:before {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;    
    background-color: #000000;
    z-index: -1;
    opacity: 0.88;
    ${breakpoints.md} {
      opacity: 0.5;
    }
  }
`;

export const ModalInner = Styled.div`
  padding: 24px;
  width:100%;
  max-width: 380px;
  min-height: 150px;
  max-height: max-content;
  ${breakpoints.md} {
    background-color: #000;
  }
  @media (max-width: ${sizes.md}px) {
    max-width: 320px;
    .icon-embed {
      display: none;
    }
  }
`;

export const TopWrapper = Styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  z-index: 1000;
  font-size: 20px;
  font-weight: bold;
`;

export const BodyWrapper = Styled.div`
 display: flex;
 justify-content: space-between;
`;

export const Label = Styled.label`
  position: absolute;
  bottom: -8px;
  transform: translateY(100%);
  color: #fff;
  text-align: center;
`;

export const IconWrapper = Styled.a`
  position: relative;
  display: inline-block;
  height: 40px;
  width: 40px;
  border: 1px solid #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:not(:hover) {
    ${Label} {
      display: none;
    }
  }

  &:hover {
    background-color: #fff;
    
    & svg, & path {
      color: #000;
    }
  }
  ${({ linkIsCopied, embedIsCopied }) =>
    (embedIsCopied || linkIsCopied) &&
    css`
      background: #fff;
    `}
`;

export const Button = Styled.button`
  padding: 4px;
  margin: 0;
  border: none;
  background: transparent;
  color: #fff;
  cursor: pointer;
`;
